export default __webpack_public_path__ + "static/media/Ocean blues_primary.6f496ba2.jpg";